import "zod/compile";
import { z } from "zod";

export const planningLevelStepKindSchema = z.enum([
  "fixed",
  "higher_of_calculated_and_floor",
  "calculated",
]);
export type PlanningLevelStepKind = z.infer<typeof planningLevelStepKindSchema>;

const planningLevelSetterSchema = z.union([
  planningLevelStepKindSchema,
  z.enum(["hard_min", "hard_max"]),
]);

export const planningLevelTraceStepSchema = z.object({
  level: z.enum(["protection", "orderUpTo"]),
  kind: planningLevelSetterSchema,
  status: z.enum(["applied", "skipped", "not_set", "lost", "clamped"]),
  value: z.number().nullable(),
  previousValue: z.number().nullable(),
  conflict: z.boolean().optional(),
});
export type PlanningLevelTraceStep = z.infer<
  typeof planningLevelTraceStepSchema
>;

export const resolvedPlanningLevelsSchema = z.object({
  protection: z.object({
    value: z.number(),
    setBy: planningLevelSetterSchema,
  }),
  orderUpTo: z.object({
    value: z.number().nullable(),
    setBy: planningLevelSetterSchema,
  }),
  trace: z.array(planningLevelTraceStepSchema),
  hardStops: z
    .object({
      min: z.number().nullable(),
      max: z.number().nullable(),
      conflict: z.boolean(),
    })
    .optional(),
});
export type ResolvedPlanningLevels = z.infer<
  typeof resolvedPlanningLevelsSchema
>;
